import { Header, Link, Menu, MenuItem, MenuTrigger, Text } from "@hopper-ui/components";
import { useShellTranslation } from "../../i18n/i18next.ts";

export const FeedbackButton = () => {
    const { t } = useShellTranslation();

    return (
        <MenuTrigger>
            <Link isStandalone paddingX="inset-sm" variant="secondary" size="sm" data-public>
                <Text>{t("FeedbackButton.label")}</Text>
            </Link>
            <Menu size="xs" data-public>
                <Header>{t("FeedbackButton.heading")}</Header>
                <MenuItem
                    href="https://outlook.office365.com/book/ShareGateUserInterview@gsoft.com/s/YxPorqK1okGULpa9Iz36BQ2"
                    target="_blank"
                >
                    <Text>{t("FeedbackButton.interview.label")}</Text>
                    <Text slot="description">{t("FeedbackButton.interview.description")}</Text>
                </MenuItem>
            </Menu>
        </MenuTrigger>
    );
};
